import {swapKeyValuePair} from '../object/swap-key-value.utils';

const map: { [s: string]: string } = {
  content_article: 'Article',
  content_blog: 'Blog',
  content_collection: 'Collection',
  content_feature: 'Feature',
  content_gallery: 'Gallery',
  content_image: 'Image',
  content_mediapost: 'Media Post',
  content_newsletter: 'Newsletter',
  content_playlist: 'Playlist',
  content_poll: 'Poll',
  content_review: 'Review',
  content_topic: 'Topic',
  content_video: 'Video',
};
export function contentTypeToName(type) {
  return map[type];
}

export function nameToContentType(name) {
  return swapKeyValuePair(map)[name];
}


// WEBPACK FOOTER //
// ./src/utils/content/content-type-to-name.utils.ts